// @ts-check

import React from "react";

import { Button } from "@shopify/polaris";
import { CalendarIcon } from "@shopify/polaris-icons";
import {
  format,
  isSameDay,
  differenceInDays,
  isYesterday,
  isToday,
  startOfWeek,
  startOfMonth,
} from "date-fns";

const TODAY = new Date();

export const ActivatorButton = ({
  dates,
  handleClick,
}) => {
  const getButtonLabel = () => {
    if (!dates) {
      return "Loading...";
    }

    if (isSameDay(dates.start, dates.end) && isToday(dates.start)) {
      return "Today";
    }

    if (isSameDay(dates.start, dates.end) && isYesterday(dates.start)) {
      return "Yesterday";
    }

    if (
      Math.abs(differenceInDays(dates.start, dates.end)) === 6 &&
      isToday(dates.end)
    ) {
      return "Last 7 Days";
    }

    if (
      Math.abs(differenceInDays(dates.start, dates.end)) === 13 &&
      isToday(dates.end)
    ) {
      return "Last 14 Days";
    }

    if (
      Math.abs(differenceInDays(dates.start, dates.end)) === 29 &&
      isToday(dates.end)
    ) {
      return "Last 30 Days";
    }

    if (
      Math.abs(differenceInDays(dates.start, dates.end)) === 89 &&
      isToday(dates.end)
    ) {
      return "Last 90 Days";
    }

    if (
      isSameDay(dates.start, startOfWeek(TODAY)) &&
      isToday(dates.end)
    ) {
      return "Week To Date";
    }

    if (
      isSameDay(dates.start, startOfMonth(TODAY)) &&
      isToday(dates.end)
    ) {
      return "Month To Date";
    }

    if (isSameDay(dates.start, dates.end)) {
      return format(new Date(dates.start), "MMM do, yyyy");
    }

    return `${format(new Date(dates.start), "MMM do, yyyy")} - ${format(
      new Date(dates.end),
      "MMM do, yyyy"
    )}`;
  };

  return (
    <Button
      onClick={handleClick}
      icon={CalendarIcon}
    >
      {getButtonLabel()}
    </Button>
  );
};
